import React from 'react';

import './styles.css';

export default function CardItem(props) {
    return (
        <div className='card-item-component'>
            <CardTag className='card-item-component-body' onClick={props.onClick}>
                <div className={'card-item-component-body-content' + (props.removeLeftSpace ? "" : " left-space")}>
                    {props.children}
                </div>
                <div className='card-item-component-body-options'>
                    {props.bodyOptions}
                </div>
            </CardTag>
            {/* transformar em link quando for clicável */}
            {/* Inserir opção de butões laterais */}
            {/* <button className='red' onClick={deleteDocument}><FaTrash /></button> */}
        </div>
    )
}

function CardTag(props) {
    return (
        props.onClick ?
            <button type='button' className={props.className} id={props.id} onClick={props.onClick}>
                {props.children}
            </button>
            :
            <div className={props.className} id={props.id}>
                {props.children}
            </div>
    )
}